<app-dialog-warning
	(passEntry)="confirmDownloadAll($event)"
	[msgVald]="message"
	[mainTitle]="title"
	[mainMessage]="bodyMessage"
	[loading]="loading"
>
</app-dialog-warning>
